import { createVuetify } from "vuetify"
import "@fontsource/roboto"
import { aliases, mdi } from "vuetify/iconsets/mdi-svg"
import { pt } from "vuetify/locale"

export default createVuetify({
  defaults: {
    VTextField: { variant: "outlined", density: "compact" },
    VSelect: { variant: "outlined", density: "compact" },
    VAutocomplete: { variant: "outlined", density: "compact" },
    VCombobox: { variant: "outlined", density: "compact" },
    VTextarea: { variant: "outlined", density: "compact" },
    VFileInput: { variant: "outlined", density: "compact" },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "dark",
    themes: {
      dark: {
        colors: {
          background: "#0d111a",
          surface: "#1a1f2b",
          "surface-bright": "#252c3d",
          "surface-variant": "#202635",
          "on-background": "#f4f7fb",
          "on-surface": "#f4f7fb",
          "on-surface-variant": "#a8b0c2",
          primary: "#4f7cff",
          secondary: "#1b2b57",
          accent: "#4f7cff",
          error: "#FF5252",
          info: "#4f7cff",
          success: "#4CAF50",
          warning: "#FB8C00",
          outline: "#2a3142",
        },
      },
      light: {
        colors: {
          primary: "#4f7cff",
          secondary: "#424242",
          accent: "#4f7cff",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FB8C00",
          background: "#F5F5F5",
          surface: "#FFFFFF",
          "on-background": "#212121",
          "on-surface": "#212121",
          "surface-bright": "#FFFFFF",
          "surface-variant": "#EEEEEE",
          "on-surface-variant": "#616161",
          outline: "#BDBDBD",
        },
      },
    },
  },
  locale: {
    locale: "pt",
    messages: { pt },
  },
})
